// extracted by mini-css-extract-plugin
export default {"contentRefWrapper":"BuyFamilyTariff__contentRefWrapper--373tW"};